import { AppConfig } from 'types/AppConfig';

const getWindowLevelPresets = (modality: string, appConfig: AppConfig) => {
	const presets = appConfig.windowLevelPresets?.find((preset) => {
		return preset.modalities.includes(modality) || preset.modalities.includes('ALL');
	})?.presets;

	return presets;
};

export default getWindowLevelPresets;
